import { useLanguage } from "../contexts/LanguageContext";

export function LanguageToggle() {
	const { language, setLanguage } = useLanguage();

	return (
		<div className="inline-flex items-center bg-secondary border border-border rounded-sm overflow-hidden">
			<button
				onClick={() => setLanguage("it")}
				className={`px-2.5 py-1 text-xs font-bold uppercase tracking-widest ${
					language === "it"
						? "bg-volt text-white"
						: "text-muted-foreground hover:text-foreground"
				}`}
			>
				IT
			</button>
			<div className="w-px h-full bg-border" />
			<button
				onClick={() => setLanguage("en")}
				className={`px-2.5 py-1 text-xs font-bold uppercase tracking-widest ${
					language === "en"
						? "bg-volt text-white"
						: "text-muted-foreground hover:text-foreground"
				}`}
			>
				EN
			</button>
		</div>
	);
}
